__turbopack_context__.v({
  "about": "About-module__vAULUW__about",
  "aboutImage": "About-module__vAULUW__aboutImage",
  "badgeNumber": "About-module__vAULUW__badgeNumber",
  "badgeText": "About-module__vAULUW__badgeText",
  "content": "About-module__vAULUW__content",
  "description": "About-module__vAULUW__description",
  "experienceBadge": "About-module__vAULUW__experienceBadge",
  "float": "About-module__vAULUW__float",
  "highlight": "About-module__vAULUW__highlight",
  "highlightIcon": "About-module__vAULUW__highlightIcon",
  "highlightText": "About-module__vAULUW__highlightText",
  "highlights": "About-module__vAULUW__highlights",
  "imageSide": "About-module__vAULUW__imageSide",
  "imageWrapper": "About-module__vAULUW__imageWrapper",
  "label": "About-module__vAULUW__label",
  "statCard": "About-module__vAULUW__statCard",
  "statCardAccent": "About-module__vAULUW__statCardAccent",
  "statIcon": "About-module__vAULUW__statIcon",
  "statLabel": "About-module__vAULUW__statLabel",
  "statNumber": "About-module__vAULUW__statNumber",
  "statsWrapper": "About-module__vAULUW__statsWrapper",
  "title": "About-module__vAULUW__title",
  "titleAccent": "About-module__vAULUW__titleAccent",
});
